<app-avatar [url]="avatarUrl()" [name]="name()"></app-avatar>
